import Monke from "../../img/2025/Mugo.jpeg";
const Puzzle1 = () => {
  return (
    <main style={{ padding: 24 }}>
      <h1>🐵 1. Mugo der Kleine – Das Größenrätsel</h1>

      <p>
        Hehehe, ich bin Mugo – der Kleinste von allen! Aber unterschätz mich
        nicht! In meinem Kopf steckt mehr Verstand, als in Hugos ganzer Banane!
        Mal sehen, ob du mein Rätsel lösen kannst, Riese!
      </p>
      <img src={Monke} style={{ maxWidth: "100%", marginBottom: "32px" }} />
      <p>
        <b style={{ fontSize: "1.2em" }}>
          Wenn du mich verdoppelst, erhältst du das dreifache von 6. Welche Zahl
          bin ich?
        </b>
      </p>
      <p>Du suchst Sugo? Der ist in der Küche ;)</p>
    </main>
  );
};

export default Puzzle1;
